import * as React from 'react';
import { EpisodeListRowContext } from './types';

const defaultContext: EpisodeListRowContext = {
  active: false,
  setContentsHeight: () => null,
};

export default React.createContext(defaultContext);
